import DistributionsScheduleModal from "./DistributionsScheduleModal"

export default DistributionsScheduleModal
